<!--
 * @Author: 张天昊
 * @Date: 2024-05-22 11:13:55
 * @LastEditTime: 2024-06-06 13:43:03
 * @LastEditors: 张天昊
 * @Description: 酒店卡片
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/HotelCard.vue
-->
<script>
import { defineComponent, ref, unref } from 'vue';
import CardContainer from './CardContainer.vue';
import Description from './Description.vue';
import { genEmptyTextPlaceholder } from '../utils';

export default defineComponent({
  components: {
    CardContainer,
    Description
  },
  props: {
    data: {
      // {
      //   title: '香格里拉大酒店(大理古城店)',
      //   from: '2024/04/25 12:30',
      //   to: '2024/04/26 12:30',
      //   catering: '含早'
      // }
      type: Array,
      default: () => []
    }
  },
  setup() {
    return {
      genEmptyTextPlaceholder
    };
  }
});
</script>

<template>
  <CardContainer>
    <template v-for="(item, index) in data">
      <van-divider v-if="index" :key="index" class="custom-divider" />
      <div :key="item.title">
        <div class="text-16 leading-20 font-medium break-all">{{ item.title }}</div>
        <Description
          class="mt-4"
          label="入住时间"
          :content="genEmptyTextPlaceholder(item.from)"
        />
        <Description
          class="mt-8"
          label="离店时间"
          :content="genEmptyTextPlaceholder(item.to)"
        />
        <Description class="mt-8" label="包含餐饮" :content="item.catering" />
      </div>
    </template>
  </CardContainer>
</template>

<style scoped>
.custom-divider {
  margin: 12px 0;
}
</style>
